import { Box, Stack } from '@atgfr8/atg-ui-tailwind';
import { LinkComponent } from '@components';
import { v4ServeDocumentUrl } from '@constants/urls';
import { DeleteIcon, UploadIcon } from '@atgfr8/icons';
import { formatDateString } from '@utils/dateFormat';

import { CommonFileUploadFiles } from './CommonFileUpload';

type PropsT = {
  file: CommonFileUploadFiles;
  onDelete: () => void;
};

export const FileCard = (props: PropsT) => {
  return (
    <Stack direction="row" p="10px 0">
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        width="50px"
      >
        <UploadIcon />
      </Box>
      <Box class="flex-1" display="flex" alignItems="center">
        <Box fontWeight={700} fontSize="14px" class="break-all leading-none">
          <LinkComponent
            url={`${v4ServeDocumentUrl.doc(
              encodeURIComponent(props.file.url as string),
            )}`}
            target={'_blank'}
            fontSize={'14px'}
            lineHeight={'1'}
            fontWeight={'700'}
            className={'break-all'}
            title={props.file.name}
          />
        </Box>
        <Box class="ml-auto text-[#444]" fontSize="14px">
          {formatDateString(props.file.dateAdded)}
        </Box>
      </Box>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        width="50px"
      >
        <DeleteIcon
          class="text-[#B00020] cursor-pointer"
          onclick={props.onDelete}
        />
      </Box>
    </Stack>
  );
};
